import { useAppDispatch } from "hooks";
import { useAppSelector } from "hooks";
import React, { useRef } from "react";
import { setShowDisableMediaRecordingModal } from "redux/actions/vdocsActions";
import styled from "styled-components";
import { eventTypes } from "types/eventTracking";
import { trackEvent } from "utils/eventTracking";
import { useConfirmPrivilege } from "utils/customHook/useConfirmPrivilege";
import { SlidFeatures } from "utils/privilegeManager";
import { setMediaRecordingChangeDirection } from "redux/actions/vdocsActions";
import { Icon } from "@slid/slid-ips";
import { useTranslation } from "react-i18next";
import { useVideoRecord } from "./utils/useVideoRecord";
import usePlaceholder from "components/NewEditor/hooks/usePlaceholder";
import useWhisperSLTStore from "store/useWhisperSLTStore";

const VideoRecordButton = () => {
  const { isRecordActive, currentDocument } = useAppSelector((state) => state.vdocs);
  const { confirmPrivilege, showInsufficientPrivilegeModal } = useConfirmPrivilege();
  const { isSTTToggledOn: isWhisperSTTToggledOn } = useWhisperSLTStore();
  const { isAutoNotesToggledOn } = useAppSelector((state) => state.autoNotes);
  const { clipRecordStart, clipRecordStop } = useVideoRecord();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { handlePlaceholderClick } = usePlaceholder();

  return (
    <CaptureButton
      onClick={async () => {
        if (!currentDocument) {
          await handlePlaceholderClick();
        }
        trackEvent({ eventType: eventTypes.click.CLIP_RECORDING_IN_VIDEO_NOTE_PAGE });
        if (!confirmPrivilege(SlidFeatures.clipRecording)) return showInsufficientPrivilegeModal();

        if (isAutoNotesToggledOn || isWhisperSTTToggledOn) {
          if (isWhisperSTTToggledOn) {
            dispatch(setMediaRecordingChangeDirection("SLT_TO_SNIPPET"));
          }
          if (isAutoNotesToggledOn) {
            dispatch(setMediaRecordingChangeDirection("AUTO_NOTES_TO_SNIPPET"));
          }
          dispatch(setShowDisableMediaRecordingModal(true));
          return;
        }
        if (isRecordActive) {
          clipRecordStop();
        } else {
          clipRecordStart();
        }
      }}
    >
      {!isRecordActive ? <Icon icon={`recording28`} color={`--gray17`} /> : <Icon icon={`usingRecording28`} color={`--red7`} />}
      <ButtonText>{!isRecordActive ? t("Record", { ns: "VideoNote" }) : t("Recording", { ns: "VideoNote" })}</ButtonText>
    </CaptureButton>
  );
};

const CaptureButton = styled.div`
  // S of reset button
  background: inherit;
  border: none;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
  outline-style: none;
  padding: 0;
  position: relative;

  &:focus {
    outline: 0;
    border: none;
  }
  // E of reset button

  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  width: 64px;
  padding: 4px 0px;
  border-radius: 15px;
  cursor: pointer;

  &:hover {
    background-color: var(--gray3);
  }

  &:active {
    background-color: var(--gray2);
  }
`;

const ButtonText = styled.span`
  font-size: 1rem;
  line-height: 1.6rem;
  text-align: center;
  color: var(--gray17);
`;

export default VideoRecordButton;
